import AlertCalendarPage from 'pages/alert-calendar'
import DetailBuilding from 'pages/building/buildingDetail'
import ViewerDetailBuilding from 'pages/building/buildingDetailViewMode'
import BuildingFileList from 'pages/building/buildingFileList'
import DetailFloor from 'pages/building/floor'
import Building from 'pages/building/listBuilding'
import ContactUs from 'pages/contact-us'
import NotificationPage from 'pages/notifications'
import OrganizationList from 'pages/organization/listOrganization'
import DetailOrganization from 'pages/organization/organizationDetail'
import RegisterOrganization from 'pages/organization/organizationRegister'
import EmailExpired from 'pages/user/invitation-expired'
import UserList from 'pages/user/listUser'
import UserRegister from 'pages/user/register'
import DetailUser from 'pages/user/userDetail'
import VersionNotFoundPage from 'pages/version-notfound'
import { RouteObject } from 'types'

import DefaultLayout from 'components/templates/DefaultLayout'
import EmptyLayout from 'components/templates/EmptyLayout'
import MainLayout from 'components/templates/MainLayout'
import DetailBuildingLayoutRN from 'components/templates/rn/DetailBuildingLayout'

const rnRoutes: RouteObject[] = [
  {
    name: 'rn-routes',
    path: '',
    layout: MainLayout,
    children: [
      {
        name: 'userList',
        path: 'rn/users',
        element: <UserList />,
        role: ['SA', 'BA', 'UA']
      },
      {
        name: 'buildings',
        path: 'rn/buildings',
        element: <Building />,
        role: ['SA', 'BA', 'UA', 'USER']
      },
      {
        name: 'buildings',
        path: 'rn/buildings/:id',
        element: <DetailBuilding />,
        layout: DetailBuildingLayoutRN,
        role: ['SA', 'BA', 'UA', 'USER']
      },
      {
        name: 'floors',
        path: 'rn/buildings/:id/floors/:floorId',
        element: <DetailFloor />,
        layout: DetailBuildingLayoutRN,
        role: ['SA', 'BA', 'UA', 'USER']
      },
      {
        name: 'organizations',
        path: 'rn/organizations',
        element: <OrganizationList />,
        role: ['SA', 'BA']
      },
      {
        name: 'organizations',
        path: 'rn/organizations/register',
        element: <RegisterOrganization />,
        role: ['SA']
      },
      {
        name: 'organizations',
        path: 'rn/organizations/:id',
        element: <DetailOrganization />,
        role: ['SA', 'BA', 'UA']
      },
      {
        name: 'users',
        path: 'rn/users/:id',
        element: <DetailUser />,
        role: ['SA', 'BA', 'UA', 'USER']
      },
      {
        name: 'contactUs',
        path: 'rn/contact-us',
        layout: DefaultLayout,
        element: <ContactUs />,
        role: ['SA', 'BA', 'UA', 'USER']
      },
      {
        name: 'alertCalendar',
        path: 'rn/alert-calendar',
        element: <AlertCalendarPage />,
        role: ['SA', 'BA', 'UA', 'USER']
      }
    ]
  },
  {
    name: 'viewer-routes',
    path: '',
    layout: MainLayout,
    children: [
      {
        name: 'buildings',
        path: 'rn/viewer/buildings/:id',
        layout: EmptyLayout,
        element: <ViewerDetailBuilding />,
        role: ['SA', 'BA', 'UA', 'USER']
      },
      {
        name: 'buildings',
        path: 'rn/viewer/buildings/:id/files',
        layout: EmptyLayout,
        element: <BuildingFileList />,
        role: ['SA', 'BA', 'UA', 'USER']
      }
    ]
  },
  {
    name: 'register-routes',
    path: '',
    layout: MainLayout,
    guardOnLogged: true,
    children: [
      {
        name: 'users',
        path: 'rn/users/register/:id/:token',
        element: <UserRegister />
      }
    ]
  },
  {
    name: 'notifications',
    path: '',
    layout: MainLayout,
    children: [
      {
        name: 'notification-list',
        path: 'rn/notifications',
        element: <NotificationPage />,
        role: ['SA']
      }
    ]
  },
  {
    name: 'invitation-expired-routes',
    path: '',
    guardOnLogged: true,
    children: [
      {
        name: 'users',
        path: 'rn/invitation-expired',
        element: <EmailExpired />
      }
    ]
  },
  {
    name: 'version-notfound-page',
    path: 'rn/version-notfound',
    children: [
      {
        name: 'notfound',
        path: '',
        layout: EmptyLayout,
        element: <VersionNotFoundPage />
      }
    ]
  }
]

export default rnRoutes
